import { __rest } from "tslib";
import React from "react";
import { Platform } from "react-native";
import Modal from "@material-ui/core/Modal";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CloseIcon from "@material-ui/icons/Close";
import { textStyle } from "../../v2/theme";
import PnmacUIButton from "../../Uibutton";
var styles = function (theme) {
  return {
    "@global": {
      "*::-webkit-scrollbar": {
        width: "0.4em"
      },
      "*::-webkit-scrollbar-track": {
        "-webkit-box-shadow": "inset 0 0 6px #003087"
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "#003087",
        outline: "1px solid #003087"
      }
    }
  };
};
var useStyles = makeStyles(function (theme) {
  return {
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    paper: {
      maxWidth: "500px",
      height: Platform.OS === 'web' ? "auto" : 400,
      maxHeight: 400,
      overflowY: "auto",
      paddingRight: 10
    },
    actions: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    },
    container: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 10,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 2, 2),
      maxWidth: "500px"
    },
    inline: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    },
    padding: {
      padding: theme.spacing(2, 0, 0)
    }
  };
});
function TermsModal(_a) {
  var _b, _c;
  var hideCancelButton = _a.hideCancelButton,
    enject = _a.enject,
    isSkipStrict = _a.isSkipStrict,
    props = __rest(_a, ["hideCancelButton", "enject", "isSkipStrict"]);
  var classes = useStyles();
  var _d = React.useState(!isSkipStrict),
    disabled = _d[0],
    setDisabled = _d[1];
  var callbackOnAccept = function () {
    var data = props.data;
    props.callbackOnAccept(data);
  };
  var handleScroll = React.useCallback(function (e) {
    var bottom = e.target.scrollHeight - e.target.scrollTop - 20 <= e.target.clientHeight;
    if (bottom) {
      setDisabled(false);
    }
  }, []);
  var open = props.open,
    data = props.data;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "modalACE"
  }, /*#__PURE__*/React.createElement(Modal, {
    className: classes.modal,
    open: open,
    onClose: props.handleClose,
    closeAfterTransition: true,
    BackdropComponent: Backdrop,
    disableScrollLock: true,
    BackdropProps: {
      timeout: 500
    },
    disableBackdropClick: props.disableClickOut,
    "data-testid": props.idTag2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container,
    "data-testid": props.idTag3
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.inline,
    "data-testid": props.idTag4
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    "data-testid": props.idTag5,
    style: textStyle.pageTitle
  }, enject ? (/*#__PURE__*/React.createElement("span", {
    className: 'htmlToNative',
    dangerouslySetInnerHTML: {
      __html: data.header
    }
  })) : data === null || data === void 0 ? void 0 : data.header)), /*#__PURE__*/React.createElement("div", {
    "data-testid": props.idTag6
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function () {
      return props.handleClose();
    }
  }, data.closeIcon ? data.closeIcon : /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement("div", {
    className: classes.paper,
    "data-testid": props.idTag7,
    onScroll: handleScroll
  }, enject ? (/*#__PURE__*/React.createElement("span", {
    className: 'htmlToNative',
    dangerouslySetInnerHTML: {
      __html: data.content
    }
  })) : data === null || data === void 0 ? void 0 : data.content, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 30
    }
  })), /*#__PURE__*/React.createElement("div", {
    "data-testid": props.idTag8
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.padding
  }, enject ? (/*#__PURE__*/React.createElement("span", {
    className: 'htmlToNative',
    dangerouslySetInnerHTML: {
      __html: data.link
    }
  })) : data === null || data === void 0 ? void 0 : data.link), /*#__PURE__*/React.createElement("div", {
    style: {
      justifyContent: hideCancelButton ? "center" : "space-between",
      flexDirection: ((_b = props.matches) === null || _b === void 0 ? void 0 : _b.small) ? 'column' : 'row'
    }
  }, hideCancelButton ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(PnmacUIButton, {
    mode: "outlined",
    onPress: function () {
      return props.handleClose();
    }
  }, data === null || data === void 0 ? void 0 : data.cancel), /*#__PURE__*/React.createElement(PnmacUIButton, {
    mode: "contained",
    disabled: disabled,
    onPress: function () {
      return callbackOnAccept();
    },
    style: {
      marginTop: ((_c = props.matches) === null || _c === void 0 ? void 0 : _c.small) ? 0 : 10
    }
  }, data === null || data === void 0 ? void 0 : data.accept))))));
}
export default withStyles(styles, {
  name: "TermsModal"
})(TermsModal);